import ErrorBoundary from 'shared/components/ErrorBoundary';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './styles.css';

const StockQuantity = ({ productStockQuantity }) => {
	const boldStyle = productStockQuantity > 0 ? { color: 'green' } : {};

	return (
		<ErrorBoundary>
			<div className={styles['product-spacer']}>
				<b style={boldStyle}>{productStockQuantity}</b>
				{` in Stock`}
			</div>
		</ErrorBoundary>
	);
};

StockQuantity.defaultProps = {
	productStockQuantity: 0,
};

StockQuantity.propTypes = {
	productStockQuantity: PropTypes.number,
};

export default StockQuantity;
